import { useContext } from 'react';
import { shallowEqual } from 'react-redux';

import { FormField } from '@zillow/constellation-10';

import { useSingleFamilyCostsAndFees } from '../../../../hooks/queries/useSingleFamilyCostsAndFees';
import { useSelector } from '../../../../selectors/useSelector';
import accessUtils from '../../../../utils/accessUtils';

import { DISPLAY_SERVER_ERROR_AT } from '../../../../constants/WizardConstants';

import { ModularListingContext } from '../../../../containers/CreateListingPage/context';

import { WizardBody, WizardFormSectionContainer, WizardHeading } from '../../../../styles/wizard';

import SFCostAndFeeOptInTotalMonthlyPriceWithFeeAlert from '../../../Alerts/SFCostAndFeeOptInTotalMonthlyPriceWithFeeAlert';
import SFCostAndFeesTotalMonthlyPriceWithFeeAlert from '../../../Alerts/SFCostAndFeesTotalMonthlyPriceWithFeeAlert';
import WizardAlert from '../../../WizardAlert';
import CostsAndFeesFormField from './CostsAndFeesFormField';

const FormSectionContainer = () => {
  const {
    modularListingState: { serverErrorObj },
  } = useContext(ModularListingContext);

  const {
    cookieEnabledServices,
    isOptInTotalMonthlyPriceWithFeeEligible,
    isTotalMonthlyPriceWithFeeEligible,
    listingAlias,
  } = useSelector((state) => {
    return {
      cookieEnabledServices: state.app.cookieEnabledServices,
      isOptInTotalMonthlyPriceWithFeeEligible:
        state.properties.currentProperty?.totalMonthlyPriceWithFee.isOptInEligible,
      isTotalMonthlyPriceWithFeeEligible: state.properties.currentProperty?.totalMonthlyPriceWithFeeNotice?.isEligible,
      listingAlias: state?.properties?.currentProperty?.listingAlias,
    };
  }, shallowEqual);

  const { data } = useSingleFamilyCostsAndFees({ listingAlias, enabled: !!listingAlias });

  const canAccessTotalMonthlyPriceWithFee = accessUtils.canAccessTotalMonthlyPriceWithFee({
    cookieEnabledServices,
    isEligible: isTotalMonthlyPriceWithFeeEligible,
  });

  if (!data) {
    return null;
  }

  return (
    <div data-testid="FormSectionContainer">
      <WizardAlert serverErrorObj={serverErrorObj} displayAt={DISPLAY_SERVER_ERROR_AT.PAGE} />

      <WizardFormSectionContainer>
        <WizardHeading level={1} textStyle="heading-sm">
          What additional costs and fees do you charge?
        </WizardHeading>

        <WizardBody>
          {isOptInTotalMonthlyPriceWithFeeEligible ? (
            <>
              These details help renters know the real cost of renting your property, and helps you meet relevant fee
              transparency laws.{' '}
            </>
          ) : (
            <>
              We&apos;ve highlighted some of the most common fee{' '}
              {canAccessTotalMonthlyPriceWithFee ? 'types' : 'categories'}. These details help renters know the real
              cost of renting your property before they apply.
            </>
          )}
        </WizardBody>

        {canAccessTotalMonthlyPriceWithFee && <SFCostAndFeesTotalMonthlyPriceWithFeeAlert />}
        {isOptInTotalMonthlyPriceWithFeeEligible && <SFCostAndFeeOptInTotalMonthlyPriceWithFeeAlert />}

        <FormField>
          <CostsAndFeesFormField displayedLocation="posting_path" />
        </FormField>
      </WizardFormSectionContainer>
    </div>
  );
};

export default FormSectionContainer;
